import React from 'react';
import PropTypes from 'prop-types';

import TextField from '../../../../../../../app/components/textField';
import DesignToggle from '../../../../../components/designToggle';
import Container from '../../../../../../../app/components/container';
import { Tabs, Tab } from '../../../../../components/tabs';

import LayoutOption from "../../tabs/layoutTab/layoutOption"
import LayoutTab from "../../tabs/layoutTab"
import CanvaFullScreen from "./CanvaFullScreen"
import CanvaMediumScreen from "./CanvaMediumScreen"
const Canva = ({ data, onChange, component, onDesignChange, appname }) => {
  const canvaLayoutOption = () =>{
    const style = {
      width: '100%',
      heigth: '100%',
    };
    return {
      options: [
        <LayoutOption
          key="canva_layout"
          wrapperKey="canva_layout"
          grid={2}
          tooltip="Change your canva component template"
          title="Canva templates"
          active={component.layout}
          items={[
            { value: 'FullScreen', icon: CanvaFullScreen, style },
            { value: 'MediumScreen', icon: CanvaMediumScreen, style },
  
          ]}
        />,
      ],
    };
  }
  return (
    <Tabs>
    <Tab label="content">
      <Container>
        <TextField
          id="title"
          name="title"
          placeholder="Enter a heading for your widget"
          value={data.title}
          onChange={value => onChange('title', value)}
        />
        <TextField
          id="url"
          name="url"
          placeholder="Enter the Design ID of your canva"
          value={data.designId}
          onChange={value => onChange('designId', value)}
        />
      </Container>
    </Tab>
    <Tab
      label="design"
      disabled
      style={{
        color: '#d9d9d9',
      }}
    >
      <DesignToggle
        component={component}
        onDesignChange={(el, isToggled) => onDesignChange(null)(el, isToggled)}
      />
      <TextField
        id="size"
        name="size"
        disabled={!component.design.enabled}
        placeholder="Enter size in px or vh. For full size use 100vh"
        value={component.design.height}
        onChange={value => onDesignChange(null)('height', value)}
      />
    </Tab>
    <Tab
      label="layout"

    >
       <LayoutTab
            componentKey={component.key}
           appname={appname}
            {...canvaLayoutOption()}
          />
          
    </Tab>
  </Tabs>
  )
}
Canva.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  component: PropTypes.object.isRequired,
  onDesignChange: PropTypes.func.isRequired,
};

export default Canva;
